const AggregatorTable = ({ data }) => {
  return (
    <>

      <div className='OverView-Main-Section min-size-marketing-1800'>
        <div className="customDash-table" >
          <div>
            <h5 style={{fontSize:'16px'}}><b>Aggregator Comparison Table</b></h5>
          </div>
          <div className='main-customized-table'>
            <table className='table'>
              <thead>
                <tr>
                  <th>Aggregators</th>
                  <th>Leads</th>
                  <th>Approval %</th>
                  <th>Disbursal %</th>
                  <th>Revenue</th>
                  <th>CPL</th>
                </tr>
              </thead>
              <tbody>
                {data?.length > 0 ? (
                  data?.map((item) => (
                    <tr key={item?.aggregatorId}>
                      <td style={{borderBottom:'1px solid #eee',background:'#fff'}}>{item?.aggregatorName}</td>
                      <td style={{borderRadius:'0',borderBottom:'1px solid #eee',background:'#fff'}}>{item?.totalLeads}</td>
                      <td style={{borderRadius:'0',borderBottom:'1px solid #eee',background:'#fff'}}>{item?.approvalPercentage}%</td>
                      <td style={{borderRadius:'0',borderBottom:'1px solid #eee',background:'#fff'}}>{item?.disbursalPercentage}%</td>
                      <td style={{borderRadius:'0',borderBottom:'1px solid #eee',background:'#fff'}}>₹{item?.totalRevenue}</td>
                      <td style={{borderBottom:'1px solid #eee',background:'#fff'}}>₹{item?.cpl}</td>
                    </tr>
                  ))
                ) : (
                  <td>No Data Found.</td>
                )}
              </tbody>
            </table>
          </div>
          {/* <div className="aggregator-table " style={{ borderTopLeftRadius: '0', borderTopRightRadius: '0', border: 'none' }}>
            <div className="summary-row">
              <div className="summary success">
                🏆 Best Performer: Aggregator C (42% margin)
              </div>
              <div className="summary danger">
                ⚠️ Underperformer: Aggregator D (22% margin)
              </div>
              <div className="summary info">📊 Average CPL: ₹277</div>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default AggregatorTable;
